<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-form @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Livro" prop="livro_id" :rules="[$requiredChange]" key="livro_id">
                        <el-select v-model="dados.livro_id" placeholder="Pesquisar livro..." filterable remote :remote-method="buscarLivros" :loading="loadingLivro" style="width: 100%;">
                            <el-option v-for="l in livros" :key="l.id" :label="formatLivro(l)" :value="l.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Tipo de usuário" prop="usuario_tipo" :rules="[$requiredChange]" key="usuario_tipo">
                        <el-select v-model="dados.usuario_tipo" @change="onTipoChange" placeholder="Selecione" style="width: 100%;">
                            <el-option label="ALUNO" value="aluno"></el-option>
                            <el-option label="SERVIDOR" value="servidor"></el-option>
                            <el-option label="FUNCIONÁRIO" value="funcionario"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Usuário (busca por nome)" prop="usuario_id" :rules="[$requiredChange]" key="usuario_id">
                        <el-select
                            v-model="dados.usuario_id"
                            placeholder="Selecione o tipo e digite o nome..."
                            filterable
                            remote
                            clearable
                            :remote-method="getLeitorByFilter"
                            :loading="loadingLeitor"
                            :disabled="!dados.usuario_tipo"
                            style="width: 100%;">
                            <el-option v-for="l in leitores" :key="l.tipo + '-' + l.id" :label="l.label" :value="l.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Digite ao menos 2 caracteres do nome.</small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Validade da reserva" prop="data_validade" :rules="[$requiredChange]" key="data_validade">
                        <el-date-picker v-model="dados.data_validade" type="date" placeholder="Selecionar data" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Observação" prop="observacao" key="observacao">
                        <el-input type="textarea" :rows="3" v-model="dados.observacao" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" class="u-text-right">
                    <el-button type="primary" id="btn-reserva" native-type="submit">REGISTRAR RESERVA</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        livros: [],
        loadingLivro: false,
        leitores: [],
        loadingLeitor: false,
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            livro_id: '',
            usuario_tipo: '',
            usuario_id: '',
            data_validade: '',
            observacao: ''
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        this.restaurarInstituicaoDoQuery();
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods: {
        restaurarInstituicaoDoQuery(){
            const qId = this.$route.query.instituicao_id;
            if(!qId) return;
            const atual = this.$store.state.config.instituicao;
            if(atual && atual.id && String(atual.id) === String(qId)) return;
            const lista = this.$store.state.instituicoes || [];
            const fromList = Array.isArray(lista)
                ? lista.find(x => x && String(x.id) === String(qId))
                : (lista[qId] || null);
            const inst = fromList || { id: qId, nome: '' };
            this.$store.commit('setInstituicao', inst);
        },
        onTipoChange(){
            this.dados.usuario_id = '';
            this.leitores = [];
        },
        getLeitorByFilter(query){
            if(!query || query.length < 2){ this.leitores = []; return; }
            if(!this.dados.usuario_tipo){
                window.eventBus.$emit('alert', {msg: 'Selecione o tipo do usuário antes de pesquisar.', type: 'warning'});
                return;
            }
            this.loadingLeitor = true;
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/leitor/searchByNome`,
                { query, tipo: this.dados.usuario_tipo },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.leitores = Array.isArray(response.data) ? response.data : [];
                this.loadingLeitor = false;
            }).catch((error) => { this.loadingLeitor = false; this.$store.commit('throwException', error); });
        },
        buscarLivros(query){
            if(!query || query.length < 2){ this.livros = []; return; }
            this.loadingLivro = true;
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/searchByNome`, { query, instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth).then(response => {
                this.livros = response.data || [];
                this.loadingLivro = false;
            }).catch((error) => { this.loadingLivro = false; this.$store.commit('throwException', error); });
        },
        formatLivro(l){
            let label = `#${l.id} - ${l.titulo}`;
            if(l.autor){ label += ` (${l.autor})`; }
            return label;
        },
        onSubmit(){
            this.$refs.dados.validate((valid) => { if(valid){
                document.getElementById('btn-reserva').focus();
                window.eventBus.$emit('loading', true);
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/reserva/store`, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível registrar a reserva.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Reserva registrada com sucesso.', type: 'success'});
                    this.$emit('onSubmit');
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        }
    }
}
</script>
